import React from 'react'
import PropTypes from 'prop-types'
import {
  InputForm,
  SelectForm,
} from 'components/Form/components'
import { Button } from 'ui-components/Button'
import Search from '@material-ui/icons/Search'
import { FormContainer, Filters, ButtonContainer } from './styles'

export default function SearchForm(props) {
  const {
    manufacturers,
    groups,
    categories,
    onSearch,
    filters,
    onChange,
  } = props

  const handleSubmit = (evt) => {
    evt.preventDefault()
    onSearch()
  }

  const handleChange = (evt) => {
    const { name, value } = evt.target
    onChange(name, value)
  }

  const handleChangeSelect = ({ name, value }) => {
    onChange(name, value)
  }

  const getSelectedById = (obj, id) => {
    if (!id) return {}

    const selected = obj.find((item) => item.value === id)
    return selected || {}
  }

  return (
    <FormContainer onSubmit={handleSubmit}>
      <Filters>
        <InputForm
          fullWidth
          label="Nome ou código"
          name="search"
          value={filters.search}
          onChange={handleChange}
        />

        <SelectForm
          native
          options={manufacturers}
          onChange={handleChangeSelect}
          value={getSelectedById(manufacturers, filters.manufacturer_id)}
          label="Fabricante"
          name="manufacturer_id"
        />

        <SelectForm
          native
          options={categories}
          value={getSelectedById(categories, filters.product_category_id)}
          onChange={handleChangeSelect}
          label="Categoria"
          name="product_category_id"
        />

        <SelectForm
          native
          options={groups}
          value={getSelectedById(groups, filters.product_group_id)}
          onChange={handleChangeSelect}
          label="Grupo"
          name="product_group_id"
        />
      </Filters>
      <ButtonContainer>
        <Button
          type="submit"
          buttonType="icon"
          size="small"
          onClick={onSearch}
        >
          <Search />
        </Button>
      </ButtonContainer>
    </FormContainer>
  )
}

SearchForm.propTypes = {
  manufacturers: PropTypes.arrayOf(PropTypes.object),
  groups: PropTypes.arrayOf(PropTypes.object),
  categories: PropTypes.arrayOf(PropTypes.object),
  onSearch: PropTypes.func.isRequired,
  filters: PropTypes.objectOf(PropTypes.any),
  onChange: PropTypes.func.isRequired,
}

SearchForm.defaultProps = {
  manufacturers: [],
  groups: [],
  categories: [],
  filters: {},
}
